import { useContext, useState } from 'react';

import { LayoutContext } from 'contexts';

import { CreateOrderForm } from 'components/CreateOrderForm';
import { Modal } from 'components/Modal';

import * as S from './OrderModal.styles';
import { Success } from './components/Success';

export function OrderModal(): React.ReactElement {
  const { isOrderModalVisibleSet } = useContext(LayoutContext);

  const [isStepTwo, isStepTwoSet] = useState<boolean>(false);

  const form = (
    <CreateOrderForm
      onSuccess={() => isStepTwoSet(true)}
      onCancel={() => isOrderModalVisibleSet(false)}
    />
  );

  return (
    <Modal onClose={() => isOrderModalVisibleSet(false)}>
      <S.Container>{isStepTwo ? <Success /> : form}</S.Container>
    </Modal>
  );
}
